<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold">
      {{ "CLIENTS.CASHING_TITLE" | translate }}
    </div>
    <button
      mat-icon-button
      type="button"
      class="panel-close-btn"
      (click)="close()"
      aria-label="Close panel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="panel-body">
    <div
      [formGroup]="form"
      class="item-full-width px-8 flex-column-center-start"
    >
      <!-- DATE -->
      <mat-form-field class="item-full-width form-field fxFlex-100p">
        <mat-label>{{ "GENERIC.DATE" | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="receiveAtDate"
          [(ngModel)]="depositIn.received_at"
          min="1900-01-01"
          formControlName="received_at"
          required
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="receiveAtDate"
        ></mat-datepicker-toggle>
        <mat-datepicker #receiveAtDate></mat-datepicker>
        <mat-error *ngIf="form.controls['received_at'].invalid"
          >{{ "GENERIC.DATE_TODAY_DOWN_RANGE_INVALID" | translate }}
        </mat-error>
      </mat-form-field>

      <!-- AMOUNT -->
      <mat-form-field class="item-full-width form-field fxFlex-100p">
        <mat-label>{{ "GENERIC.AMOUNT" | translate }}</mat-label>
        <input
          matInput
          type="text"
          formControlName="amount"
          autocomplete="nope"
          pattern="^[0-9]+([.,][0-9]{1,2})?"
          [ngModel]="amountInput"
          (ngModelChange)="onNewAmount($event)"
          (blur)="onAmountBlur()"
          required
        />
        <mat-error *ngIf="form.controls['amount'].invalid">
          {{ "GENERIC.INPUT_NUMBER_ABOVE_ZERO" | translate }}
        </mat-error>
      </mat-form-field>

      <!-- PAYMENT MODES -->
      <app-gt2-select
        name="select2"
        [service]="paymentModesService"
        [placeHolder]="'CLIENTS.PAYMENT_MODES' | translate"
        [label]="''"
        [isRequired]="true"
        [selectedModel]="depositIn.payment_mode"
        (changeEvent)="onPaymentModeChange($event)"
        [noResultsLabel]="translate.instant('GENERIC.NO_RESULTS')"
        [nullableUseNone]="false"
        class="item-full-width form-field fxFlex-100p"
        required
      ></app-gt2-select>

      <div [formGroup]="formRef" class="item-full-width">
        <mat-form-field class="item-full-width form-field fxFlex-100p">
          <mat-label>{{ "CLIENTS.REFERENCE_NUMBER" | translate }}</mat-label>
          <input
            matInput
            formControlName="ref_number"
            autocomplete="nope"
            type="text"
            [(ngModel)]="depositIn.ref_number"
          />
          <mat-error *ngIf="formRef.controls['ref_number'].invalid"
            >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="invoices" class="item-full-width flex-column">
        <div class="selected-invoices">
          {{ "CLIENTS.SELECTED_INVOICES" | translate }}
        </div>
        <div class="flex-row-start-center fxFlex">
          <div class="fxFlex-20p col-invoice">
            {{ "CLIENTS.ENTERPRISE_INVOICE_NUMBER" | translate }}
          </div>
          <div class="fxFlex-20p col-static">
            {{ "GENERIC.TOTAL" | translate }}
          </div>
          <div class="fxFlex-20p col-static">
            {{ "CLIENTS.PAID_AMOUNT" | translate }}
          </div>
          <div class="fxFlex-20p col-balance">
            {{ "CLIENTS.BALANCE" | translate }}
          </div>
          <div class="fxFlex-20p col-cashing">
            {{ "CLIENTS.CASHING_COLUMN" | translate }}
          </div>
        </div>
        <div
          *ngFor="let invoice of invoicesModel"
          class="invoice-item flex-row-start-center"
        >
          <app-enterprise-cashing-invoice
            class="fxFlex"
            (onUpdate)="crunchTotal()"
            [invoice]="invoice"
          >
          </app-enterprise-cashing-invoice>
        </div>
        <div class="total-table-footer flex-row-start-center">
          <div class="fxFlex-20p col-invoice">&nbsp;</div>
          <div class="fxFlex-20p col-static">
            {{ countryContext.symbol$ | async
            }}{{ totalInvoicesTotal | number: "1.2-2" }}
          </div>
          <div class="fxFlex-20p col-static">
            {{ countryContext.symbol$ | async
            }}{{ totalPaidAmount | number: "1.2-2" }}
          </div>
          <div class="fxFlex-20p col-balance">
            {{ countryContext.symbol$ | async
            }}{{ totalBalanceAmount | number: "1.2-2" }}
          </div>
          <div class="fxFlex-20p total-cashing-cell col-cashing">
            {{ countryContext.symbol$ | async
            }}{{ totalEnteredRounded | number: "1.2-2" }}
          </div>
        </div>
        <div class="total-table-balance">
          {{ "CLIENTS.BALANCE" | translate }}:
          {{ countryContext.symbol$ | async
          }}{{ remainingBalance | number: "1.2-2" }}
        </div>
      </div>
    </div>

    <div class="item-full-width note-section mt-8 flex-column-center-start">
      <div class="note-label">{{ "GENERIC.NOTE" | translate }}</div>
      <p-editor
        #noteEditor
        [(ngModel)]="depositIn.note"
        [style]="{
          height: '112px',
          width: '100%',
          'background-color': '#ffffff',
          resize: 'vertical',
          overflow: 'auto',
        }"
        class="item-full-width"
      >
        <ng-template pTemplate="header" class="">
          <!-- <span class="ql-formats">
            <select class="ql-font"></select>
            <select class="ql-size"></select>
          </span> -->

          <span class="ql-formats">
            <button class="ql-bold"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
            <button class="ql-strike"></button>
          </span>

          <span class="ql-formats">
            <select class="ql-color"></select>
            <select class="ql-background"></select>
          </span>

          <span class="ql-formats">
            <button class="ql-list" value="ordered"></button>
            <button class="ql-list" value="bullet"></button>
            <button class="ql-indent" value="-1"></button>
            <button class="ql-indent" value="+1"></button>
          </span>

          <span class="ql-formats">
            <app-emoji-picker-button
              [editor]="noteEditor"
            ></app-emoji-picker-button>
          </span>
        </ng-template>
      </p-editor>
      <mat-error *ngIf="noteInvalid" class="p-4 pr-8 flex-row-end-center">
        {{ "GENERIC.NOTE_EDITOR_LENGTH_INVALID_2048" | translate }}
      </mat-error>
    </div>
  </div>

  <footer class="panel-footer gt2-buttons-theme flex-row-center-center">
    <button
      mat-raised-button
      color="accent"
      [disabled]="
        loading ||
        form.invalid ||
        !depositIn.amount ||
        depositIn.amount <= 0 ||
        amountExceedsInvoices ||
        !depositIn.received_at ||
        !depositIn.payment_mode
      "
      class="mr-8 ml-8 mt-4 mb-4"
      (click)="onCreateCashings()"
    >
      {{ "GENERIC.SAVE" | translate }}
    </button>

    <button
      mat-raised-button
      color="primary"
      (click)="close()"
      class="mr-8 ml-8 mt-4 mb-4"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </footer>
</div>
